export function initSearchPreviewsFilter(): void {
  const filterBar = document.querySelector<HTMLElement>("[data-sp-filter]");
  const table = document.querySelector<HTMLElement>("[data-sp-table]");
  if (!filterBar || !table) return;

  const rows = Array.from(table.querySelectorAll<HTMLElement>("[data-sp-row]"));
  const searchInput = filterBar.querySelector<HTMLInputElement>("[data-sp-search]");
  const statusBtns = Array.from(filterBar.querySelectorAll<HTMLElement>("[data-sp-status-btn]"));
  const shownEl = document.querySelector<HTMLElement>("[data-sp-shown]");
  const noResults = document.querySelector<HTMLElement>("[data-sp-noresults]");

  let status = "all";
  let query = "";

  const apply = (): void => {
    let shown = 0;
    rows.forEach((row) => {
      const matchesStatus = status === "all" || row.dataset.spStatus === status;
      const matchesQuery = query === "" || (row.dataset.spText || "").includes(query);
      const visible = matchesStatus && matchesQuery;
      row.style.display = visible ? "" : "none";
      if (visible) shown += 1;
    });
    if (shownEl) shownEl.textContent = String(shown);
    if (noResults) noResults.hidden = shown !== 0;
  };

  searchInput?.addEventListener("input", () => {
    query = searchInput.value.trim().toLowerCase();
    apply();
  });

  statusBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      status = btn.dataset.spStatusBtn || "all";
      statusBtns.forEach((b) => b.classList.toggle("active", b === btn));
      apply();
    });
  });

  apply();
}
